import * as React from 'react';
import type { SVGProps } from 'react';

const SvgAddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1600}
    height={1600}
    fill="#B1B1B1"
    viewBox="0 0 1200 1200"
    {...props}
  >
    <path d="M600 208.16a391.813 391.813 0 0 0-277.07 114.77C249.446 396.414 208.16 496.08 208.16 600s41.281 203.59 114.77 277.07C396.414 950.554 496.08 991.84 600 991.84s203.59-41.281 277.07-114.77C950.554 803.586 991.84 703.92 991.84 600s-41.281-203.59-114.77-277.07A391.841 391.841 0 0 0 600 208.16zm0 759.18c-97.426 0-190.86-38.703-259.75-107.59a367.344 367.344 0 0 1 0-519.5 367.344 367.344 0 0 1 519.5 0 367.344 367.344 0 0 1 0 519.5A367.344 367.344 0 0 1 600 967.34z" />
    <path d="M612.25 433.47h-24.492v154.29h-154.29v24.492h154.29v154.29h24.492v-154.29h154.29V587.76H612.25z" />
  </svg>
);
export default SvgAddIcon;
